import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, primaryBlack, blueSecondary, fontMBank } = styles;

export const StatusScreenContainer = styled.div<{ isLoading?: boolean; height?: number }>`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem;

  ${props =>
    props.isLoading &&
    ` padding: 0
      height: ${props.height}px;
  `}
`;

export const StatusScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};
`;

export const StatusScreenStatus = styled.div`
  max-width: 25rem;
  margin: 0 auto;
  font-size: 2rem;
  line-height: 1.25;
  text-align: center;
  color: ${primaryBlack};
`;

export const StatusScreenStatusText = styled.div`
  max-width: 25rem;
  margin: 0 auto;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${blueSecondary};
  margin-bottom: 1.5rem;
`;

export const StatusScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const StatusScreenMessage = styled.div`
  color: ${primaryBlack};
  font-family: ${fontMBank};
  font-size: 1.375rem;
  line-height: 1.32;
  margin-bottom: 1.4rem;
`;

export const StatusScreenButton = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 0.6875rem;
  overflow: hidden;
  button {
    background-color: ${blueSecondary};
    border-color: ${blueSecondary};
    border-radius: 0.6875rem;
    color: ${white};
    padding: 0.625rem 4.5rem;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.125rem;
    text-transform: uppercase;
    font-family: ${fontMBank};
    outline: none;
    cursor: pointer;
`;

export const StatusScreenRetryMessage = styled.div`
  color: ${primaryBlack};
  font-family: ${fontMBank};
  font-size: 1rem;
  line-height: 1.32;
  margin-bottom: 1.1875rem;
`;
